import { render, staticRenderFns } from "./CreateAffiliateCard.vue?vue&type=template&id=6a63ad73"
import script from "./CreateAffiliateCard.vue?vue&type=script&lang=ts"
export * from "./CreateAffiliateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports